import React from 'react'
import Head from './Head'
import Header from './Header'
import Footer from './Footer'
import PullToRefresh from './PullToRefresh'
import { PersistentUploadIndicator } from './UploadProgress'

interface LayoutProps {
  children: React.ReactNode
  title?: string
  description?: string
  noIndex?: boolean
  /** Canonical URL (absolute) for SEO */
  canonical?: string
  /** Image URL for og:image (e.g. post/profile image) */
  image?: string
  /** Descriptive alt text for the social image; defaults to title */
  imageAlt?: string
  /** Open Graph type: article (posts), profile (users), website (default) */
  ogType?: 'website' | 'article' | 'profile'
  /** With ogType `profile`, sets OG `profile:username` */
  profileUsername?: string
  /** ISO timestamp; only meaningful when ogType === 'article' */
  articlePublishedTime?: string
  /** ISO timestamp; only meaningful when ogType === 'article' */
  articleModifiedTime?: string
  /** Author display name; only meaningful when ogType === 'article' */
  articleAuthor?: string
  jsonLd?: string
}

const Layout: React.FC<LayoutProps> = ({
  children,
  title,
  description,
  noIndex,
  canonical,
  image,
  imageAlt,
  ogType,
  profileUsername,
  articlePublishedTime,
  articleModifiedTime,
  articleAuthor,
  jsonLd,
}) => {
  return (
    <PullToRefresh>
      <Head
        title={title}
        description={description}
        noIndex={noIndex}
        canonical={canonical}
        image={image}
        imageAlt={imageAlt}
        ogType={ogType}
        profileUsername={profileUsername}
        articlePublishedTime={articlePublishedTime}
        articleModifiedTime={articleModifiedTime}
        articleAuthor={articleAuthor}
        jsonLd={jsonLd}
      />
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:start-2 focus:z-[100] focus:bg-blue-600 focus:text-white focus:px-3 focus:py-2 focus:rounded"
      >
        پرش به محتوای اصلی
      </a>
      <Header />
      <main id="main-content" role="main" className="pb-16 md:pb-6 native-main-bottom">
        {children}
      </main>
      <Footer />
      <PersistentUploadIndicator />
    </PullToRefresh>
  )
}

export default Layout
